import rights from '../../../components/rights';
import globalToast from '$$vueCmp/toast';

export default function (instance) {
  instance.hasRight = (ganttId, bitKey) => rights.project.hasRight(ganttId, bitKey);
  instance.hasRightSomeOne = (ganttId, bitKeys) => rights.project.hasRightSomeOne(ganttId, bitKeys);
  instance.hasRightToEditField = (ganttId, fieldName) => {
    const staticFields = ['attachments', 'text', 'resource_id', 'start_date', 'end_date', 'duration', 'estimation', 'time_tracking', 'progress', 'status', 'priority'];
    const staticFieldsFourOnly = ['attachments', 'time_tracking', 'progress', 'status'];
    const canEditStaticFields = rights.project.hasRight(ganttId, 'static_fields') && staticFields.includes(fieldName);
    const canEditStaticFieldsFourOnly = rights.project.hasRight(ganttId, 'static_fields_4_only') && staticFieldsFourOnly.includes(fieldName);
    const canEditCustomFields = rights.project.hasRight(ganttId, 'custom_field_edit') && fieldName.includes('custom');
    const canEditTaskLinks = rights.project.hasRight(ganttId, 'task_links') && fieldName === 'predecessors';
    const projectAutoBudget = instance.ganttDataApi.getProjectAutoBudget(ganttId);
    const canEditBudget = ['total_price', 'actual_cost'].includes(fieldName) && !projectAutoBudget;

    return canEditStaticFields || canEditStaticFieldsFourOnly || canEditCustomFields || canEditTaskLinks || canEditBudget;
  };
  instance.hasAccessToTask = task => {
    if (!task) return false;
    if (rights.project.hasRight(task.gantt_id, 'all_tasks')) return true;

    const userId = rights.getUserId();
    const resourceData = instance.ganttDataApi.getResourceByUserId(userId);

    return task.resources?.find(r => r.resource_id === resourceData.id);
  };

  instance.canEditColumn = (task, columnId) => {
    const currentProject = instance.ganttDataApi.getProjectColumnsDataByProjectId(task.gantt_id);
    const isColumn = currentProject?.columns.includes(+columnId);

    if (!isColumn && task.parent !== 0) {
      globalToast.warning(__('msg_cant_edit_column'));

      return false;
    }

    return true;
  };
}
